import moment from 'moment';
import { Card, Row, Col } from 'react-bootstrap';
import HelperService from '../utility/HelperService';

interface propData {
    data: any
}

const InvoiceQuote = (props: propData) => {
    return (
        <>
            <div>
                <Card className="card-style form-style p-4" style={{ marginBottom: 50 }}>
                    <Row>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote #</p>
                            <p className="font-14 mb-0">{props?.data?.quoteInfo?.quoteNum ? props?.data?.quoteInfo?.quoteNum : '-'}</p>
                        </Col>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote Date</p>
                            <p className="font-14 mb-0">{props?.data?.quoteInfo?.quoteDate ? moment(props?.data?.quoteInfo?.quoteDate).format('MM/DD/YY') : '-'}</p>
                        </Col>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Amount</p>
                            <p className="font-14 mb-0">{props?.data?.quoteInfo?.quoteAmount ? "$" + HelperService.getCurrencyFormatter(props?.data?.quoteInfo?.quoteAmount) : '-'}</p>
                        </Col>
                    </Row>
                    <div className='mt-4'>
                        <p className="mb-0 font-w-medium font-14">Name</p>
                        <p className="font-14 mb-0">{props?.data?.quoteInfo?.quoteName ? props?.data?.quoteInfo?.quoteName : '-'}</p>
                    </div>
                    <div className='mt-4'>
                        <p className="mb-0 font-w-medium font-14">Description</p>
                        <p className="font-14 mb-0">{props?.data?.quoteInfo?.quoteDescription ? props?.data?.quoteInfo?.quoteDescription : '-'}</p>
                    </div>
                </Card>
            </div>
        </>
    )
}

export default InvoiceQuote;